export function defaultLinkLabel(url) {
  try {
    return new URL(url).hostname.replace(/^www\./, '');
  } catch {
    return 'link';
  }
}

export function getItemLinks(item) {
  if (!item) {
    return [];
  }

  const links = [];
  const seen = new Set();

  const push = (url, label) => {
    if (!url || seen.has(url)) {
      return;
    }
    seen.add(url);
    links.push({
      url,
      label: label?.trim() || defaultLinkLabel(url),
    });
  };

  if (Array.isArray(item.links)) {
    item.links.forEach((entry) => {
      if (typeof entry === 'string') {
        push(entry);
        return;
      }
      if (entry?.url) {
        push(entry.url, entry.label);
      }
    });
  }

  if (typeof item.link === 'string') {
    push(item.link);
  }

  return links;
}
